import { useMutation } from 'react-query';
import { post, patch } from '@/lib/fetch';

export async function createAvaSubscription(params = {}) {
  const { data } = await post('/billing/ava_subscriptions', params);

  return data;
}

export async function updateAvaSubscription(params = {}) {
  const { data } = await patch('/billing/ava_subscriptions', params);

  return data;
}

export async function updateAvaSubscriptionPaymentMethod(params = {}) {
  const { data } = await patch('/billing/ava_subscriptions/update_payment_method', params);

  return data;
}

export async function generateAvaSecondCharge(params = {}) {
  const { data } = await post('/billing/ava_subscriptions/generate_second_charge', params);

  return data;
}

export function useCreateAvaSubscription({ config = {} } = {}) {
  return useMutation(
    createAvaSubscription,
    { ...config }
  );
}

export function useUpdateAvaSubscription({ config = {} } = {}) {
  return useMutation(
    updateAvaSubscription,
    { ...config }
  );
}

export function useGenerateAvaSecondCharge({ config = {} } = {}) {
  return useMutation(
    generateAvaSecondCharge,
    { ...config }
  );
}

export function useUpdateAvaSubscriptionPaymentMethod({ config = {} } = {}) {
  return useMutation(
    updateAvaSubscriptionPaymentMethod,
    { ...config }
  );
}
